angular.module('agreements')
    .component('dfTable', {
        bindings: {
            agreementId: '<',
            projectId: '<',
            ids: '<',
            query: '<',
            includeConfidential: '<',
            onDataLoaded: '&',
        },
        templateUrl: 'app/agreements/df/df-table.html',
        controller: function ($scope, modals, Invoice, InvoiceService, AgreementConst, BusinessThread) {

            this.$onChanges = () => {
                this.load()
            }

            this.load = () => {
                if (angular.isArray(this.ids) && !this.ids.length) {
                    this.page = {list: [], fullListSize: 0, objectsPerPage: 50, pageNumber: 1}
                    if (angular.isFunction(this.onDataLoaded)) {
                        this.onDataLoaded({$page: this.page});
                    }
                    return
                }

                let params = {
                    agreementId: this.agreementId,
                    mainProject: this.projectId,
                    ids: this.ids,
                    search: this.query
                }
                let resource = this.includeConfidential === true ? BusinessThread.invoiceTable : Invoice.allGranted
                if (this.includeConfidential === true) {
                    params.includeConfidential = true
                }
                return resource(params).$promise.then(result => {
                    this.page = result;
                    if (angular.isFunction(this.onDataLoaded)) {
                        this.onDataLoaded({$page: this.page});
                    }
                })
            }

            $scope.$on(AgreementConst.eventUpdate, () => this.$onChanges())
        }
    })
